import Swiper from "swiper";
//import 'swiper/swiper-bundle.css';

const initializeSwipersProdutosEmpresas = () => {
  const container = document.querySelector("#produtos-empresas");
  if (!container) return;

	

  const swiperConfigs = [
    {
      swiperClass: ".swiper-empresas",
      paginationClass: ".swiper-pagination-empresas",
      numeracaoClass: ".swiper-numeracao-empresas",
      btnNextClass: ".swiper-button-next-empresas",
      btnPrevClass: ".swiper-button-prev-empresas",
			numeracao: document.querySelector(".swiper-numeracao-empresas-ativo"),
			setNumeracao: (_n) => {
				swiperConfigs[0].numeracao.innerText = (_n < 10) ? "0" + _n : _n;
			},
			numeracaoTotal: document.querySelector(".swiper-numeracao-empresas-total"),
			setNumeracaoTotal: () => {
				let n = document.querySelectorAll(".swiper-pagination-empresas .swiper-pagination-bullet").length;
				swiperConfigs[0].numeracaoTotal.innerText = (n < 10) ? "0" + n : n;
			}
    },
    {
      swiperClass: ".swiper-empresas-especificas",
      paginationClass: ".swiper-pagination-empresas-especificas",
      numeracaoClass: ".swiper-numeracao-empresas-especificas",
      btnNextClass: ".swiper-button-next-empresas-especificas",
      btnPrevClass: ".swiper-button-prev-empresas-especificas",
			numeracao: document.querySelector(".swiper-numeracao-empresas-especificas-ativo"),
			setNumeracao: (_n) => {
				swiperConfigs[1].numeracao.innerText = (_n < 10) ? "0" + _n : _n;
			},
			numeracaoTotal: document.querySelector(".swiper-numeracao-empresas-especificas-total"),
			setNumeracaoTotal: () => {
				let n = document.querySelectorAll(".swiper-pagination-empresas-especificas .swiper-pagination-bullet").length;
				swiperConfigs[1].numeracaoTotal.innerText = (n < 10) ? "0" + n : n;
			}
    }
  ];


	/** Swiper Empresas */
  const swiperEmpresas = new Swiper(swiperConfigs[0].swiperClass, {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 24,
    navigation: {
      nextEl: swiperConfigs[0].btnNextClass,
      prevEl: swiperConfigs[0].btnPrevClass,
    },
    pagination: {
      el: swiperConfigs[0].paginationClass,
      clickable: true,
    },
    breakpoints: {
      1920: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      1280: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      640: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
    },
    on: {
      init: function () {
        const totalBarras = document.querySelectorAll(`${swiperConfigs[0].paginationClass} .swiper-pagination-bullet`).length;
        swiperConfigs[0].setNumeracaoTotal(totalBarras);
        swiperConfigs[0].setNumeracao(1);
      },
      slideChange: function () {
        const activeBullet = document.querySelector(`${swiperConfigs[0].paginationClass} .swiper-pagination-bullet.swiper-pagination-bullet-active`);
        if (!activeBullet) return;

        const index = [...activeBullet.parentElement.children].indexOf(activeBullet) + 1;
        swiperConfigs[0].setNumeracao(index);
      },
      resize: function () {
        const totalBarras = document.querySelectorAll(`${swiperConfigs[0].paginationClass} .swiper-pagination-bullet`).length;
        swiperConfigs[0].setNumeracaoTotal(totalBarras);
      }
    }

  });

	/** Swiper Empresas : Produtos Específicos */
	const swiperEmpresasProdutosEspecificos = new Swiper(swiperConfigs[1].swiperClass, {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    spaceBetween: 24,
    navigation: {
      nextEl: swiperConfigs[1].btnNextClass,
      prevEl: swiperConfigs[1].btnPrevClass,
    },
    pagination: {
      el: swiperConfigs[1].paginationClass,
      clickable: true,
    },
    breakpoints: {
      1280: {
        slidesPerView: 3.5,
        slidesPerGroup: 3.5,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      640: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
    },
    on: {
      init: function () {
        const totalBarras = document.querySelectorAll(`${swiperConfigs[1].paginationClass} .swiper-pagination-bullet`).length;
        swiperConfigs[1].setNumeracaoTotal(totalBarras);
        swiperConfigs[1].setNumeracao(1);
      },
      slideChange: function () {
        const activeBullet = document.querySelector(`${swiperConfigs[1].paginationClass} .swiper-pagination-bullet.swiper-pagination-bullet-active`);
        if (!activeBullet) return;

        const index = [...activeBullet.parentElement.children].indexOf(activeBullet) + 1;
        swiperConfigs[1].setNumeracao(index);
      },
      resize: function () {
        const totalBarras = document.querySelectorAll(`${swiperConfigs[1].paginationClass} .swiper-pagination-bullet`).length;
        swiperConfigs[1].setNumeracaoTotal(totalBarras);
      }
    }

  });
}


export default initializeSwipersProdutosEmpresas;
